/**
 * usePresetChoices: the training presets that fit a benchmark's routes,
 * as TrainingFields lists them and the Add benchmark dialog sends the
 * chain's default. Each reader calls it alone: the presets need GitHub,
 * and a trainer it cannot read must fail the training fields, never the
 * form around them.
 */

import { useListTrainingPresetsApiInternalTrainingPresetsGet } from '@/api/generated/internal/internal'
import { presetChoices, type PresetChoices } from '@/components/internal/team-config/training'

export function usePresetChoices(routes: readonly string[]): {
  choices: PresetChoices | undefined
  error: unknown
} {
  const query = useListTrainingPresetsApiInternalTrainingPresetsGet()
  const offered = query.data?.status === 200 ? query.data.data : undefined
  return {
    choices:
      offered === undefined
        ? undefined
        : presetChoices(offered.presets, routes, offered.default_preset),
    error: query.isError ? query.error : null,
  }
}
